// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"401":"6679c868","573":"9dd58769","965":"f9601170","987":"06becbb7"}[chunkId] + ".chunk.css";
};